<template>
  <div class="exchange-i">
    <Header title="毕业设计" type="0" route="/homeIndex"></Header>
    
    <div class="list-head">
              <div>
                <p><label style=" font-family: PingFangSC-Medium;font-size: 16px;font-weight: bolder;">届别</label><span @click="showPop()">
                  <i>{{byjb}}</i>
                  <b></b>
                </span></p>
              </div>
             
            </div>
            <NOdata
      v-if="this.designReCodeList && this.designReCodeList.length == 0"
      title="未查询到任何信息"
    ></NOdata>       
    <div class="exchange">
      <div
        class="item"
        v-for="(item, index) of designReCodeList"
        :key="index"
        @click="toGuideal(item)"
      >
        <ul>
          <li><label>题目编号：</label>{{ item.ktbh }}</li>
          <li><label>设计（论文）题目：</label>{{ item.ktmc }}</li>
          <li><label>学科门类：</label>{{ item.xkml }}</li>
          <li><label>选中人数：</label><span >{{ item.xzrs }}</span></li>
        </ul>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        title="届别"
        show-toolbar
        :columns="valueList"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(index);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      show:false,
      valueList: [],
      byjbDataList:[],
      byjb:'',
      designReCodeList: [],
    };
  },
  methods: {
    showPop() {
      this.show = true;
    },
    onConfirm(index) {
      this.show = false;
      if(this.valueList[index].value!=this.byjb){
        this.byjb = this.valueList[index].value;
        this.loadMyDesignmsg();
      }
      
    },
    async loadByjbMsg(){
      const res = await Api.loadByjbMsg();
      if(res.code=='1'){
        this.byjbDataList = res.data;
        let dqjb = "";
        for(let i=0;i<this.byjbDataList.length;i++){
          let imtt = {"text":this.byjbDataList[i].jb,"value":this.byjbDataList[i].jb};
          this.valueList.push(imtt);
          if(this.byjbDataList[i].dqsyzt=='1'){
            dqjb = this.byjbDataList[i].jb;
          }
        }
        this.byjb = dqjb;
        if(this.byjb!=''){
          this.loadMyDesignmsg();
        }
      }
    },
    async loadMyDesignmsg(){
      const params = {
        byjb: this.byjb,
      };
      const res = await Api.loadMyDesignmsg(params);
      if(res.code=='1'){
        this.designReCodeList = res.data;
      }
    },
    toGuideal(item){
      this.$router.push({
          path: "/design/guideStudentMsg",
          query: {
            itemObj:JSON.stringify(item)
          }
        });
    }
  },
  created() {
    this.loadByjbMsg();
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .list-head {
      height: 60px;
      background-image: url("../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding: 6% 7%;
      box-sizing: border-box;
      margin-bottom: 1%;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      div {
        width: 90%;
        height: 100%;
        p {
          font-size: 14px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        
      
        span {
          
          align-items: center;
          i {
            font-style: normal;
            font-size: 14px;
            color: #fff;
            margin-right: 5%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 80%;
            margin-left: 15px;
          }
          b {
            display: inline-block;
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;
            border-top: 3px solid #fff;
          }
        }
      }
    }
  .exchange {
    padding: 5% 5% 0;
    overflow: auto;
    height: 80vh;
    .item {
      background: #f8f8f8;
      border-radius: 8px;
      margin: 0 auto 5%;
      padding: 3% 3% 3% 6%;
      box-sizing: border-box;

      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      ul {
        li {
          font-family: PingFangSC-Light;
          font-size: 14px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 1%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
          min-height: 16px;
        }

        li label {
          height: 16px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          line-height: 16px;
          margin-bottom: 1%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
        } 

        li span{
          color:blue;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Design/design_msg.vue